import { Typography } from '../primitives/index.js'
import type { FC } from 'react'

export interface EmptyLinksProps {
  text?: string
}

export const EmptyLinks: FC<EmptyLinksProps> = props => {
  const { text = 'No links' } = props
  return (
    <Typography
      style={{ display: 'flex', justifyContent: 'center', color: 'var(--tuna-palette-text-disabled)' }}
      variant="caption"
    >
      {text}
    </Typography>
  )
}

export default EmptyLinks
